import React from 'react'

const Chevron = ({ height = 20, width = 60, color = 'white' } = {}) => (
  <div style={{ position: 'relative' }}>
    <div
      style={{
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        height,
        borderTop: `solid ${color} ${height}px`,
        borderRight: `solid transparent ${width / 2}px`,
        borderLeft: `solid transparent ${width / 2}px`,
        width,
      }}
    />
  </div>
)
export default Chevron



// WEBPACK FOOTER //
// ./components/Chevron.js